'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import SVGWrapper from './SVGWrapper';

var SVGImage = function SVGImage(props) {
  return React.createElement(SVGWrapper, props);
};

SVGImage.propTypes = {
  image: PropTypes.string
};
export default SVGImage;